import axios from 'axios'

export default function() {
  // If the DOM is not yet ready, add a callback for when it is.
  document.addEventListener("DOMContentLoaded", setCSRFToken);
  // If it is ready, just execute the code.
  if (document.readyState === "interactive" || document.readyState === "complete" ) { setCSRFToken() }
}

const setCSRFToken = () => {
  const csrfToken = document.querySelector("meta[name=csrf-token]").content
  axios.defaults.headers.common["X-CSRF-Token"] = csrfToken
}
